import { render } from "./VerifySuccessAnimation.vue?vue&type=template&id=4220276a&scoped=true&ts=true"
import script from "./VerifySuccessAnimation.vue?vue&type=script&lang=ts"
export * from "./VerifySuccessAnimation.vue?vue&type=script&lang=ts"

import "./VerifySuccessAnimation.vue?vue&type=style&index=0&id=4220276a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4220276a"]])

export default __exports__